<template>
  <div @click="change_test_mask">
    <div class="test_mask"></div>
    <img :class="type == 'd' ? 'd' : 'r'" src="@/assets/img/h5/hand.gif" />
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  props: {
    type: {
      type: String,
    }
  },
  mounted() {

  },
  methods: {
    /*隐藏test_mask*/
    change_test_mask() {
      this.$store.commit('showPubAlertBgH5', false)
      localStorage.setItem('firstTime', true)
    },
  },
}
</script>
<style lang="less" scoped>
.test_mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999998;
}

img {
  position: absolute;
  width: 2rem;
  height: 1.4rem;
  z-index: 999999;
  &.d {
    top: 0;
    left: 50%;
    margin-left: -1rem;
  }
  &.r {
    top: 50%;
    right: 15%;
    transform: translate(0, -50%);
  }
}
</style>
